import {
  OTREQUESTORDER_ALL,
  OTREQUESTORDER_GET,
  OTREQUESTORDER_PUT,
  OTREQUESTORDER_DEL,
  OTREQUESTORDER_POST,
  OTREQUESTORDER_LOADING,
  OTREQUESTORDER_ERROR,
} from '../../actions/types';

const initialState = {
  otRequestOrder: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case OTREQUESTORDER_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case OTREQUESTORDER_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case OTREQUESTORDER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case OTREQUESTORDER_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case OTREQUESTORDER_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case OTREQUESTORDER_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case OTREQUESTORDER_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case 'OT_REQUEST_UPDATE_LOCAL':
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case 'OT_REQUEST_ORDER_UPDATE_LOCAL':
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
